import { styled } from '@mui/material';

export const DrawerScrollContainer = styled('div')({
  height: '100%',
  overflowY: 'auto',
  position: 'relative',
});
